import React from 'react';
import { useTranslation } from 'react-i18next';
import { useClient } from '@context/presentation';
import { ScriptHeader } from '../styles';
import { Line } from '@slides/styles';
import { isAttorneyProfile } from '@utils/profileUtils';

export const SectionOne = () => {
    const { t } = useTranslation();
    const { firm, firmShortName } = useClient();
    const profileIsAttorney = isAttorneyProfile(firmShortName)

    return (
        <>
            <ScriptHeader>
                {t('we_can_help.script.title1')}
                {firmShortName}
                {t('we_can_help.script.title2')}
            </ScriptHeader>
            <Line />
            <div>
                {t('we_can_help.script.1')}
                <strong>{firm}</strong>
                {t('we_can_help.script.2')}
                {
                    profileIsAttorney ? t('we_can_help.script.attorney_label') : t('we_can_help.script.contingency_label')
                }
                {t('we_can_help.script.firm_intro')}
            </div>
            <ul>
                <li><strong>{t('we_can_help.script.high_apr')}</strong>{t('we_can_help.script.3')}</li>
                <li><strong>{t('we_can_help.script.no_loan')}</strong>{t('we_can_help.script.4')}</li>
            </ul>
        </>
    );
};
